import { render, staticRenderFns } from "./CreateNewEmailForm.vue?vue&type=template&id=3374990a&scoped=true&"
import script from "./CreateNewEmailForm.vue?vue&type=script&lang=ts&"
export * from "./CreateNewEmailForm.vue?vue&type=script&lang=ts&"
import style0 from "./CreateNewEmailForm.vue?vue&type=style&index=0&id=3374990a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3374990a",
  null
  
)

export default component.exports